<script lang="ts" setup>
  import { computed, inject, type ComputedRef } from 'vue'
  import BaseModal from '@/shared/components/BaseModal/BaseModal.vue'

  const modelValue = defineModel<boolean>({ default: false })
  const isRtl = inject('isRTL') as ComputedRef<boolean>

  const isShown = computed({
    get: () => modelValue.value,
    set: (val) => {
      modelValue.value = val
    },
  })

  const imagePath = computed(
    () =>
      new URL(
        `/src/shared/assets/images/ramadan/body-gifts-${isRtl.value ? 'ar' : 'en'}.png`,
        import.meta.url
      ).href
  )
</script>

<template>
  <BaseModal
    id="ramadan-modal"
    :is-open="modelValue"
    :show-close-button="false"
    @close="modelValue = false"
  >
    <div class="ramadan-modal">
      <div class="ramadan-modal__close-button">
        <button aria-label="close modal" @click="isShown = false">
          <img src="@/shared/assets/images/ramadan/x.svg" alt="close icon" />
        </button>
      </div>
      <div class="ramadan-modal__texts">
        <p class="ramadan-modal__title">{{ $t('ramadan.popup.header') }}</p>
        <div>
          <p class="ramadan-modal__subtitle">{{ $t('ramadan.popup.subtitle.1') }}</p>
          <div>
            {{ $t('ramadan.popup.subtitle.2') }}
            <img src="@/shared/assets/images/ramadan/ticket.svg" alt="ticket" />
            {{ $t('ramadan.popup.subtitle.3') }}
          </div>
        </div>
      </div>

      <div :class="['ramadan-modal__body', { rtl: isRtl }]">
        <img :src="imagePath" :alt="isRtl ? 'ar' : 'en'" />
      </div>
    </div>
  </BaseModal>
</template>

<style lang="scss">
  @import './RamadanModal';
</style>

<style scoped lang="scss">
  .rtl {
    .ramadan-modal {
      background-position-x: -23px;
    }
  }
</style>
